/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1200
 */

module.exports = {
  spinner: "Spinner_spinner__1Nh-g",
  spinnerPath: "Spinner_spinnerPath__2LlP3",
  "coco-spinner-dash": "Spinner_coco-spinner-dash__1-lIC"
}
